// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: Arial, sans-serif;
}

.title h3{
    background-color: #6699cc;
    color: #ffffff;
    padding: 10px;
    text-align: left;
  }

.center-content {
    margin: auto !important;
    text-align: center;
}

.dropdown-container {
    display: flex;
    gap: 20px;
    align-items: center;
    margin-top: 20px;
}

.dropdown-container label {
    margin-right: 10px;
}

#doa-category, #doa-types, #orderby {
    width: 300px;
    height: 32px;
}

#orderby {
    width: 150px;
}

.button-container {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;
}

table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

th, td {
    border: 1px solid white;
    text-align: center;
    padding: 8px;
}

table th {
    background-color: #0b2d71;
    color: white;
    font-weight: bold;
}

td a {
    color: blue;
    text-decoration: none; 
}

td a:hover {
    text-decoration: underline; 
}

.mat-elevation-z8 {
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.mat-paginator {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
#submit{
    margin-top: 25px; 
}
.bordered-container {
    border: 1px solid #d3d3d3; 
    padding: 20px;
    max-width: 100%;
    margin: 3% 0%;
    border-radius: 1px;
    padding-bottom: 1%;
   }
.color{
    /* background-color: #6699cc; */
    color: #0b2d71;
    /* width: 1140px;
    height: 50px; */
    /* display: flex;
    justify-content: center;
    align-items: center; */
  }
  .error-message {
    color: red;
    font-weight: bold;
  }`, "",{"version":3,"sources":["webpack://./src/app/modules/delegationofauthority/bydoatype/bydoatype.component.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;;AAEF;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2HAA2H;AAC/H;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,kBAAkB;GACnB;AACH;IACI,+BAA+B;IAC/B,cAAc;IACd;mBACe;IACf;;0BAEsB;EACxB;EACA;IACE,UAAU;IACV,iBAAiB;EACnB","sourcesContent":["body {\n    font-family: Arial, sans-serif;\n}\n\n.title h3{\n    background-color: #6699cc;\n    color: #ffffff;\n    padding: 10px;\n    text-align: left;\n  }\n\n.center-content {\n    margin: auto !important;\n    text-align: center;\n}\n\n.dropdown-container {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n    margin-top: 20px;\n}\n\n.dropdown-container label {\n    margin-right: 10px;\n}\n\n#doa-category, #doa-types, #orderby {\n    width: 300px;\n    height: 32px;\n}\n\n#orderby {\n    width: 150px;\n}\n\n.button-container {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 20px;\n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n}\n\nth, td {\n    border: 1px solid white;\n    text-align: center;\n    padding: 8px;\n}\n\ntable th {\n    background-color: #0b2d71;\n    color: white;\n    font-weight: bold;\n}\n\ntd a {\n    color: blue;\n    text-decoration: none; \n}\n\ntd a:hover {\n    text-decoration: underline; \n}\n\n.mat-elevation-z8 {\n    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);\n}\n\n.mat-paginator {\n    margin-top: 20px;\n    display: flex;\n    justify-content: center;\n}\n#submit{\n    margin-top: 25px; \n}\n.bordered-container {\n    border: 1px solid #d3d3d3; \n    padding: 20px;\n    max-width: 100%;\n    margin: 3% 0%;\n    border-radius: 1px;\n    padding-bottom: 1%;\n   }\n.color{\n    /* background-color: #6699cc; */\n    color: #0b2d71;\n    /* width: 1140px;\n    height: 50px; */\n    /* display: flex;\n    justify-content: center;\n    align-items: center; */\n  }\n  .error-message {\n    color: red;\n    font-weight: bold;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
